import { createQueryKeys } from '@lukemorales/query-key-factory';
import {
  getTradeEligibilityList,
  lazadaLogisticsList,
  logisticsList,
  LogisticsListParams,
  tradeList,
  TradeListParams,
} from 'services/api/conversation';
import { queryCancelOrderList, queryReturnListV2 } from 'services/api/refund';

export const orders = createQueryKeys('orders', {
  /** 订单详情 */
  detail: (params: { externalTradeId: string; storeId: string; buyerId: string }) => ({
    queryKey: [params],
    queryFn: async ({ signal }) =>
      tradeList(
        {
          external_trade_ids: params.externalTradeId,
          internal_store_id: params.storeId,
          external_buyer_id: params.buyerId,
          page_no: 1,
          page_size: 1,
        },
        undefined,
        signal,
      ),
  }),
  /** 订单列表 */
  list: (params: TradeListParams) => ({
    queryKey: [params],
    queryFn: async ({ signal }) => tradeList(params, undefined, signal),
  }),
  /** Lazada 物流信息 */
  lazadaLogistics: (params: LogisticsListParams) => ({
    queryKey: [params],
    queryFn: async ({ signal }) => lazadaLogisticsList(params, signal),
  }),
  /** 物流信息 */
  logistics: (params: LogisticsListParams) => ({
    queryKey: [params],
    queryFn: async ({ signal }) => logisticsList(params, signal),
  }),
  eligibility: (params: { internalTradeIds: string[] }) => ({
    queryKey: [params],
    queryFn: ({ signal }) => getTradeEligibilityList(params, signal),
  }),
  /** 订单详情-关联的取消订单 */
  cancelOrderRelated: (params: {
    orderId: string;
    platform: General.PlatformUpperCase;
    pageSize: number;
  }) => ({
    queryKey: [params],
    queryFn: async ({ signal }) =>
      queryCancelOrderList(
        {
          ...params,
          pageNo: '1',
          pageSize: params.pageSize.toString(),
        },
        signal,
      ),
  }),
  returnOrderRelated: (params: {
    orderSn: string;
    platform: General.Platform;
    pageSize: number;
  }) => ({
    queryKey: [params],
    queryFn: async ({ signal }) =>
      queryReturnListV2(
        {
          ...params,
          page: {
            pageNo: 1,
            pageSize: params.pageSize,
          },
        },
        signal,
      ),
  }),
});
